import RouteNames from "@/app/router/routes";
import store from "@/app/store/store";
import { TextHelper } from "@/app/utils/text-helper";
import AlarmTypeVue from "@/app/vues/admin/alarm-type.vue";
import AlarmTypesVue from "@/app/vues/admin/alarm-types.vue";
import EventTypeVue from "@/app/vues/company/event-type.vue";
import EventTypesVue from "@/app/vues/company/event-types.vue";
import ApplicationsVue from "@/app/vues/admin/applications.vue";
import ApplicationVue from "@/app/vues/admin/application.vue";
import BlockTypesVue from "@/app/vues/admin/block-types.vue";
import SMTPImporterSettingsVue from "@/app/vues/admin/smtp-importer-settings.vue";
import SMTPImporterLogsVue from "@/app/vues/admin/smtp-import-logs.vue";
import CompaniesVue from "@/app/vues/admin/companies.vue";
import CompanyVue from "@/app/vues/admin/company.vue";
import ComponentTypesVue from "@/app/vues/admin/component-types.vue";
import DischargeVue from "@/app/vues/company/discharge.vue";
import MeasurementTypesVue from "@/app/vues/admin/measurement-types.vue";
import RegionsVue from "@/app/vues/admin/regions.vue";
import SiteVue from "@/app/vues/admin/site.vue";
import SitesVue from "@/app/vues/admin/sites.vue";
import UserVue from "@/app/vues/admin/user.vue";
import UsersVue from "@/app/vues/admin/users.vue";
import AlarmsVue from "@/app/vues/company/alarms.vue";
import ArtificialNotificationAddressesVue from "@/app/vues/company/artificial-notification-addresses.vue";
import MaintenanceHistoryVue from "@/app/vues/company/maintenance-history.vue";
import MaintenanceLogVue from "@/app/vues/company/maintenance-log.vue";
import ManufacturersVue from "@/app/vues/company/manufacturers.vue";
import ManufacturerVue from "@/app/vues/company/manufacturer.vue";
import ModelVue from "@/app/vues/company/model.vue";
import NotificationsVue from "@/app/vues/company/notifications.vue";
import EventsVue from "@/app/vues/company/events.vue";
import IssueVue from "@/app/vues/company/issue.vue";
import IssuesVue from "@/app/vues/company/issues.vue";
import NotificationHistoryVue from "@/app/vues/company/notification-history.vue";
import ReportManagerVue from "@/app/vues/reports/report-manager.vue";
import ReportUserPermissionsVue from "@/app/vues/reports/report-user-permissions.vue";
import StringSnapshotVue from "@/app/vues/company/string-snapshot.vue";
import ControllerRealtimeDataVue from "@/app/vues/company/controller-realtime-data.vue";
import SystemCommunicationsVue from "@/app/vues/company/system-communications.vue";
import SystemRegistrationVue from "@/app/vues/company/system-registration.vue";
import SystemVue from "@/app/vues/company/system.vue";
import SystemsVue from "@/app/vues/company/systems.vue";
import TrendVue from "@/app/vues/company/trend.vue";
import ErrorsVue from "@/app/vues/errors/errors.vue";
import ChangePasswordVue from "@/app/vues/public/change-password.vue";
import ForgottenPasswordVue from "@/app/vues/public/forgotten-password.vue";
import LoginVue from "@/app/vues/public/login.vue";
import SsoCallbackVue from "@/app/vues/public/sso-callback.vue";
import TwoFactorAuthVue from "@/app/vues/public/two-factor-auth.vue";
import DataGaps from "@/app/vues/admin/data-gaps.vue";
import ComponentLimitsVue from "@/app/vues/admin/component-limits.vue";
import AboutVue from "@/app/vues/admin/about.vue";
import HomeVue from "@/app/vues/shared/home.vue";
import ProfileVue from "@/app/vues/shared/profile.vue";
import TermsVue from "@/app/vues/shared/terms.vue";
import { HostingOptionEnum, AssureEditionEnum } from "@/app/api/battery-portal-api";
import { isLicenseAllowed } from "@/app/utils/license-helper";
import { getPermissionsForEdition } from "@/app/utils/license-helper";
import NProgress from "nprogress";
import { createRouter, createWebHistory } from 'vue-router';
const powershieldPermission = "powershield";
const powershieldAdministratorPermission = "powershieldAdministrator";
const clientAdministratorPermission = "clientAdministrator";
const clientInstallerPermission = "clientInstaller";
const routes = [
    {
        path: "/",
        name: RouteNames.Home,
        component: HomeVue,
        meta: {
            title: TextHelper.getPageTitle("Status Overview")
        }
    },
    {
        path: "/alarms",
        name: RouteNames.Alarms,
        component: AlarmsVue,
        meta: {
            title: TextHelper.getPageTitle("Alarms")
        }
    },
    {
        path: "/alarms/system-:systemId",
        name: RouteNames.AlarmsForSystem,
        component: AlarmsVue,
        meta: {
            title: TextHelper.getPageTitle("Alarms")
        }
    },
    {
        path: "/alarms/system-:systemId/alarmSeverity-:alarmSeverity",
        name: RouteNames.AlarmsForSystem,
        component: AlarmsVue,
        meta: {
            title: TextHelper.getPageTitle("Alarms")
        }
    },
    {
        path: "/alarms/system-:systemId/alarmSeverity-:alarmSeverity/acknowledgeStatus-:acknowledgeStatus",
        name: RouteNames.AlarmsForSystem,
        component: AlarmsVue,
        meta: {
            title: TextHelper.getPageTitle("Alarms")
        }
    },
    {
        path: "/alarm-type/:id?",
        name: RouteNames.AlarmType,
        component: AlarmTypeVue,
        meta: {
            title: TextHelper.getPageTitle("Alarm Type"),
            permission: [powershieldPermission],
            licenseRule: { hostingOption: HostingOptionEnum.PowershieldCloud }
        }
    },
    {
        path: "/alarm-types",
        name: RouteNames.AlarmTypes,
        component: AlarmTypesVue,
        meta: {
            title: TextHelper.getPageTitle("Alarm Types"),
            permission: [powershieldPermission],
            licenseRule: { hostingOption: HostingOptionEnum.PowershieldCloud }
        }
    },
    {
        path: "/event-type/:companyId/:id?",
        name: RouteNames.EventType,
        component: EventTypeVue,
        meta: {
            title: TextHelper.getPageTitle("Event Type"),
            permission: [powershieldPermission, clientAdministratorPermission],
            licenseRule: { minimumEdition: AssureEditionEnum.OnPremStandard }
        }
    },
    {
        path: "/event-types",
        name: RouteNames.EventTypes,
        component: EventTypesVue,
        meta: {
            title: TextHelper.getPageTitle("Event Types"),
            permission: [powershieldPermission, clientAdministratorPermission],
            licenseRule: { minimumEdition: AssureEditionEnum.OnPremStandard }
        }
    },
    {
        path: "/manufacturer/:companyId/:id?",
        name: RouteNames.Manufacturer,
        component: ManufacturerVue,
        meta: {
            title: TextHelper.getPageTitle("Manufacturer"),
            permission: [powershieldPermission, clientAdministratorPermission, clientInstallerPermission]
        }
    },
    {
        path: "/manufacturers",
        name: RouteNames.Manufacturers,
        component: ManufacturersVue,
        meta: {
            title: TextHelper.getPageTitle("Manufacturers"),
            permission: [powershieldPermission, clientAdministratorPermission, clientInstallerPermission]
        }
    },
    {
        path: "/model/:companyId/:manufacturerId?/:id?",
        name: RouteNames.Model,
        component: ModelVue,
        meta: {
            title: TextHelper.getPageTitle("Model"),
            permission: [powershieldPermission, clientAdministratorPermission, clientInstallerPermission]
        }
    },
    {
        path: "/applications",
        name: RouteNames.Applications,
        component: ApplicationsVue,
        meta: {
            title: TextHelper.getPageTitle("Applications"),
            licenseRule: { hostingOption: HostingOptionEnum.PowershieldCloud }
        }
    },
    {
        path: "/application/:id?",
        name: RouteNames.Application,
        component: ApplicationVue,
        meta: {
            title: TextHelper.getPageTitle("Application"),
            licenseRule: { hostingOption: HostingOptionEnum.PowershieldCloud }
        }
    },
    {
        path: "/notifications",
        name: RouteNames.Notifications,
        component: NotificationsVue,
        meta: {
            title: TextHelper.getPageTitle("Notifications"),
            permission: [powershieldPermission, clientAdministratorPermission],
            licenseRule: { minimumEdition: AssureEditionEnum.OnPremStandard }
        }
    },
    {
        path: "/events/:eventId?",
        name: RouteNames.Events,
        component: EventsVue,
        meta: {
            title: TextHelper.getPageTitle("Events"),
            licenseRule: { minimumEdition: AssureEditionEnum.OnPremStandard }
        }
    },
    {
        path: "/notifications/history",
        name: RouteNames.NotificationHistory,
        component: NotificationHistoryVue,
        props: { showTitle: true },
        meta: {
            title: TextHelper.getPageTitle("Notifications"),
            permission: [powershieldPermission, clientAdministratorPermission],
            licenseRule: { minimumEdition: AssureEditionEnum.OnPremStandard }
        }
    },
    {
        path: "/notifications/settings",
        name: RouteNames.ArtificialAddresses,
        component: ArtificialNotificationAddressesVue,
        props: { showTitle: true },
        meta: {
            title: TextHelper.getPageTitle("Notification Settings"),
            permission: [powershieldPermission, clientAdministratorPermission],
            licenseRule: { minimumEdition: AssureEditionEnum.OnPremStandard }
        }
    },
    {
        path: "/discharge",
        name: RouteNames.Discharge,
        component: DischargeVue,
        meta: {
            title: TextHelper.getPageTitle("Discharge"),
            licenseRule: { minimumEdition: AssureEditionEnum.OnPremStandard }
        }
    },
    {
        path: "/trend",
        name: RouteNames.Trend,
        component: TrendVue,
        meta: {
            title: TextHelper.getPageTitle("Trend"),
            licenseRule: { minimumEdition: AssureEditionEnum.OnPremStandard }
        }
    },
    {
        path: "/trend/system-:systemId",
        name: RouteNames.TrendForSystem,
        component: TrendVue,
        meta: {
            title: TextHelper.getPageTitle("Trend"),
            licenseRule: { minimumEdition: AssureEditionEnum.OnPremStandard }
        }
    },
    {
        path: "/trend/system-:systemId/string-:stringId/uom-:measurementTypeId?/startDate-:startDate?/endDate-:endDate?",
        name: RouteNames.TrendForString,
        component: TrendVue,
        meta: {
            title: TextHelper.getPageTitle("Trend"),
            licenseRule: { minimumEdition: AssureEditionEnum.OnPremStandard }
        }
    },
    {
        path: "/trend/system-:systemId/string-:stringId/block-:blockId",
        name: RouteNames.TrendForBlock,
        component: TrendVue,
        meta: {
            title: TextHelper.getPageTitle("Trend"),
            licenseRule: { minimumEdition: AssureEditionEnum.OnPremStandard }
        }
    },
    {
        path: "/trend/system-:systemId/string-:stringId/block-:blockId/uom-:measurementTypeId?/status-:stringStatusId?",
        name: RouteNames.TrendForMeasurement,
        component: TrendVue,
        meta: {
            title: TextHelper.getPageTitle("Trend"),
            licenseRule: { minimumEdition: AssureEditionEnum.OnPremStandard }
        }
    },
    {
        path: "/snapshot",
        name: RouteNames.Snapshot,
        component: StringSnapshotVue,
        meta: {
            title: TextHelper.getPageTitle("Snapshot")
        }
    },
    {
        path: "/snapshot/system-:systemId",
        name: RouteNames.SnapshotForSystem,
        component: StringSnapshotVue,
        meta: {
            title: TextHelper.getPageTitle("Snapshot")
        }
    },
    {
        path: "/snapshot/system-:systemId/string-:stringId?",
        name: RouteNames.SnapshotForString,
        component: StringSnapshotVue,
        meta: {
            title: TextHelper.getPageTitle("Snapshot")
        }
    },
    {
        path: "/real-time",
        name: RouteNames.RealTime,
        component: ControllerRealtimeDataVue,
        meta: {
            title: TextHelper.getPageTitle("Real-Time"),
            licenseRule: { hostingOption: HostingOptionEnum.OnPrem }
        }
    },
    {
        path: "/login",
        name: RouteNames.Login,
        component: LoginVue,
        meta: {
            title: TextHelper.getPageTitle("Login")
        }
    },
    {
        path: "/sso-callback",
        name: RouteNames.SsoCallback,
        component: SsoCallbackVue,
        meta: {
            title: TextHelper.getPageTitle("SSO Login")
        }
    },
    {
        path: "/two-factor-auth",
        name: RouteNames.TwoFactorAuth,
        component: TwoFactorAuthVue,
        meta: {
            title: TextHelper.getPageTitle("Two Factor Authentication")
        }
    },
    {
        path: "/logout",
        name: RouteNames.Logout,
        component: LoginVue
    },
    {
        path: "/forgotten-password",
        name: RouteNames.ForgottenPassword,
        component: ForgottenPasswordVue,
        meta: {
            title: TextHelper.getPageTitle("Forgot Your Password?"),
        }
    },
    {
        path: "/change-password",
        name: RouteNames.ChangePassword,
        component: ChangePasswordVue,
        meta: {
            title: TextHelper.getPageTitle("Change Your Password"),
        }
    },
    {
        path: "/companies",
        name: RouteNames.Companies,
        component: CompaniesVue,
        meta: {
            title: TextHelper.getPageTitle("Companies"),
            //permission: [powershieldPermission, clientAdministratorPermission]
        }
    },
    {
        path: "/company/:id?",
        name: RouteNames.Company,
        component: CompanyVue,
        meta: {
            title: TextHelper.getPageTitle("Company"),
            permission: [powershieldPermission, , clientAdministratorPermission],
        }
    },
    {
        path: "/sites/:id?",
        name: RouteNames.Sites,
        component: SitesVue,
        meta: {
            title: TextHelper.getPageTitle("Sites"),
            permission: [powershieldPermission, clientAdministratorPermission],
        }
    },
    {
        path: "/site/:id?/:companyId?/",
        name: RouteNames.Site,
        component: SiteVue,
        meta: {
            title: TextHelper.getPageTitle("Site"),
            permission: [powershieldPermission, clientAdministratorPermission],
        }
    },
    {
        path: "/systems/:id?",
        name: RouteNames.Systems,
        component: SystemsVue,
        meta: {
            title: TextHelper.getPageTitle("Systems")
        }
    },
    {
        path: "/system/:id?/:companyId?/",
        name: RouteNames.System,
        component: SystemVue,
        meta: {
            title: TextHelper.getPageTitle("System")
        }
    },
    {
        path: "/register-system/:id?",
        name: RouteNames.SystemRegistration,
        component: SystemRegistrationVue,
        meta: {
            title: TextHelper.getPageTitle("Register System")
        }
    },
    {
        path: "/communications/:id?",
        name: RouteNames.Communications,
        component: SystemCommunicationsVue,
        meta: {
            title: TextHelper.getPageTitle("Comms")
        }
    },
    {
        path: "/users",
        name: RouteNames.Users,
        component: UsersVue,
        meta: {
            title: TextHelper.getPageTitle("Users"),
            permission: [powershieldPermission, clientAdministratorPermission]
        }
    },
    {
        path: "/user/:id?/:companyId?/",
        name: RouteNames.User,
        component: UserVue,
        meta: {
            title: TextHelper.getPageTitle("User"),
            permission: [powershieldPermission, clientAdministratorPermission]
        }
    },
    {
        path: "/regions",
        name: RouteNames.Regions,
        component: RegionsVue,
        meta: {
            title: TextHelper.getPageTitle("Geographic Regions"),
            permission: [powershieldAdministratorPermission]
        }
    },
    {
        path: "/block-types",
        name: RouteNames.BlockTypes,
        component: BlockTypesVue,
        meta: {
            title: TextHelper.getPageTitle("Block Types"),
            permission: [powershieldAdministratorPermission],
            licenseRule: { hostingOption: HostingOptionEnum.PowershieldCloud }
        }
    }, {
        path: "/smtp-importer-settings",
        name: RouteNames.SMTPImporterSettings,
        component: SMTPImporterSettingsVue,
        meta: {
            title: TextHelper.getPageTitle("SMTP Importer Settings"),
            permission: [powershieldAdministratorPermission],
            licenseRule: { hostingOption: HostingOptionEnum.PowershieldCloud }
        }
    },
    {
        path: "/smtp-importer-logs",
        name: RouteNames.SMTPImporterLogs,
        component: SMTPImporterLogsVue,
        meta: {
            title: TextHelper.getPageTitle("SMTP Importer Logs"),
            permission: [powershieldAdministratorPermission],
            licenseRule: { hostingOption: HostingOptionEnum.PowershieldCloud }
        }
    },
    {
        path: "/component-types",
        name: RouteNames.ComponentTypes,
        component: ComponentTypesVue,
        meta: {
            title: TextHelper.getPageTitle("Measurement Types"),
            permission: [powershieldAdministratorPermission],
            licenseRule: { hostingOption: HostingOptionEnum.PowershieldCloud }
        }
    },
    {
        path: "/measurement-types",
        name: RouteNames.MeasurementTypes,
        component: MeasurementTypesVue,
        meta: {
            title: TextHelper.getPageTitle("Measurement Types"),
            permission: [powershieldAdministratorPermission],
            licenseRule: { hostingOption: HostingOptionEnum.PowershieldCloud }
        }
    },
    {
        path: "/issues",
        name: RouteNames.Issues,
        component: IssuesVue,
        meta: {
            title: TextHelper.getPageTitle("Issues"),
            licenseRule: { minimumEdition: AssureEditionEnum.OnPremStandard }
        }
    },
    {
        path: "/issue/:id?",
        name: RouteNames.Issue,
        component: IssueVue,
        meta: {
            title: TextHelper.getPageTitle("Issue"),
            licenseRule: { minimumEdition: AssureEditionEnum.OnPremStandard }
        }
    },
    {
        path: "/comments",
        name: RouteNames.MaintenanceComments,
        component: MaintenanceHistoryVue,
        meta: {
            title: TextHelper.getPageTitle("Comments"),
        }
    },
    {
        path: "/comment/:id?",
        name: RouteNames.MaintenanceComment,
        component: MaintenanceLogVue,
        meta: {
            title: TextHelper.getPageTitle("Comment"),
        }
    },
    {
        path: "/reports",
        name: RouteNames.Reports,
        component: ReportManagerVue,
        meta: {
            title: TextHelper.getPageTitle("Reports"),
        }
    },
    {
        path: "/report-permissions",
        name: RouteNames.ReportPermissions,
        component: ReportUserPermissionsVue,
        meta: {
            title: TextHelper.getPageTitle("Report Permissions"),
        }
    },
    {
        path: "/data-gaps",
        name: RouteNames.DataGaps,
        component: DataGaps,
        meta: {
            title: TextHelper.getPageTitle("Data Gaps"),
            permission: [powershieldAdministratorPermission],
            licenseRule: { hostingOption: HostingOptionEnum.PowershieldCloud }
        }
    },
    {
        path: "/component-limits",
        name: RouteNames.ComponentLimits,
        component: ComponentLimitsVue,
        meta: {
            title: TextHelper.getPageTitle("Component Limits"),
            permission: [powershieldPermission, clientAdministratorPermission],
            //licenseRule: { hostingOption: HostingOptionEnum.PowershieldCloud }
        }
    },
    {
        path: "/about",
        name: RouteNames.About,
        component: AboutVue,
        meta: {
            title: TextHelper.getPageTitle("About"),
            conditionalPermission: [
                { hostingOption: HostingOptionEnum.OnPrem, role: clientInstallerPermission },
                { hostingOption: HostingOptionEnum.PowershieldCloud, role: powershieldAdministratorPermission }
            ]
        }
    },
    {
        path: "/me",
        name: RouteNames.MyProfile,
        component: ProfileVue,
        meta: {
            title: TextHelper.getPageTitle("My Details")
        }
    },
    {
        path: "/errors",
        name: RouteNames.Errors,
        component: ErrorsVue
    },
    {
        path: "/terms-and-conditions",
        name: RouteNames.Terms,
        component: TermsVue
    },
    {
        path: '/:pathMatch(.*)',
        name: RouteNames.CatchAll,
        redirect: "/"
    },
];
export const router = createRouter({
    // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
    history: createWebHistory(),
    routes, // short for `routes: routes`
    scrollBehavior: (to, from, savedPosition) => {
        return { left: 0, top: 0 };
    }
});
router.beforeEach((to, from, next) => {
    const publicPages = ["/login", "/logout", "/errors", "/two-factor-auth", "/sso-callback"];
    const publicPagesAccessibleToUnauthenticatedUsersOnly = ["/forgotten-password", "/change-password"];
    const isRestricted = !publicPages.concat(publicPagesAccessibleToUnauthenticatedUsersOnly).includes(to.path);
    const isLoggedIn = store.getters["loginModule/isLoggedIn"];
    const isPowerShield = store.getters["loginModule/isPowerShield"];
    const isPowerShieldAdministrator = store.getters["loginModule/isPowerShieldAdministrator"];
    const isClientAdministrator = store.getters["loginModule/isClientAdministrator"];
    const isClientInstaller = store.getters["loginModule/isClientInstaller"];
    const mustAcceptTerms = store.getters["loginModule/isAcceptanceOfTermsRequired"]();
    const appTitle = store.getters["appConfigModule/appTitle"];
    const appReleaseDesignation = store.getters["appConfigModule/appReleaseDesignation"];
    let appName = [appReleaseDesignation, appTitle].filter(text => text).join(' | ');
    if (publicPagesAccessibleToUnauthenticatedUsersOnly.includes(to.path) && isLoggedIn)
        return next("/login");
    if (isRestricted && !isLoggedIn)
        return next("/login");
    if (isLoggedIn && mustAcceptTerms && !publicPages.concat(`/${RouteNames.Terms}`).includes(to.path))
        return next(`/${RouteNames.Terms}`);
    if (appName.length > 0) {
        let nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
        if (nearestWithTitle)
            document.title = `${appName} - ${nearestWithTitle.meta.title}`;
        else
            document.title = `${appName}`;
    }
    if (to.meta.licenseRule) {
        if (!isLicenseAllowed(to.meta.licenseRule)) {
            return next("/");
        }
    }
    if (to.meta.conditionalPermission) {
        let permissions = to.meta.conditionalPermission;
        let filteredPermissions = getPermissionsForEdition(permissions);
        console.log(filteredPermissions);
        if (filteredPermissions.length === 0)
            return next("/login");
        const roleStrictness = {
            [clientInstallerPermission]: 1,
            [clientAdministratorPermission]: 2,
            [powershieldPermission]: 3,
            [powershieldAdministratorPermission]: 4,
        };
        const rank = (p) => { var _a; return (p.role ? (_a = roleStrictness[p.role]) !== null && _a !== void 0 ? _a : 0 : 0); };
        const strictestRule = filteredPermissions.reduce((strictest, current) => rank(current) > rank(strictest) ? current : strictest);
        const requiredRole = rank(strictestRule);
        //if no role defined - edition match alone is enough.
        if (requiredRole === 0)
            return next();
        // Effective user rank is the highest role flag the user currently has.
        let userRank = 0;
        if (isClientInstaller)
            userRank = Math.max(userRank, roleStrictness[clientInstallerPermission]);
        if (isClientAdministrator)
            userRank = Math.max(userRank, roleStrictness[clientAdministratorPermission]);
        if (isPowerShield)
            userRank = Math.max(userRank, roleStrictness[powershieldPermission]);
        if (isPowerShieldAdministrator)
            userRank = Math.max(userRank, roleStrictness[powershieldAdministratorPermission]);
        if (userRank >= requiredRole)
            return next();
        return next("/login");
    }
    if (to.meta.permission) {
        let permissions = to.meta.permission;
        if (permissions.includes(clientInstallerPermission) && isClientInstaller)
            return next();
        if (permissions.includes(clientAdministratorPermission) && isClientAdministrator)
            return next();
        if (permissions.includes(powershieldPermission) && isPowerShield)
            return next();
        if (permissions.includes(powershieldAdministratorPermission) && isPowerShieldAdministrator)
            return next();
        return next("/login");
    }
    next();
});
router.beforeResolve((to, from, next) => {
    if (to.name)
        NProgress.start();
    next();
});
router.afterEach((to, from) => {
    NProgress.done();
});
